import request from '@/utils/request'

/**
 * 购物车列表
 * @param {*} data
 */
export const get_cart_list = data => {
  return request({
    url: `/user/cart/list`,
    method: 'post',
    data: data
  })
}
/**
 * 添加到购物车
 * @param {*} data
 */
export const add_cart = data => {
  return request({
    url: `/user/cart/add`,
    method: 'post',
    data: data
  })
}
/**
 * 添加到购物车
 * @param {*} data
 */
export const del_cart = data => {
  return request({
    url: `/user/cart/del`,
    method: 'post',
    data: data
  })
}
/**
 * 修改商品数量
 * @param {*} data
 */
export const edit_cart_quantity = data => {
  return request({
    url: `/user/cart/edit/quantity`,
    method: 'post',
    data: data
  })
}

// 获取购物车商品数量
export const get_cart_product_count = params => {
  return request({
    url: `/user/cart/product/count`,
    method: 'get',
    params
  })
}
